import * as React from "react";
import Lottie from "react-lottie";

import commentsLoader from "./assets/commentsLoader.json";
import sendingLoader from "./assets/sendingLoader.json";
import sendAnimation from "./assets/sendAnimation.json";
import emptyComments from "./assets/emptyComments.json";
import loadingReplies from "./assets/loadingReplies.json";
import calendarLoader from "./assets/calendarLoader.json";
import userLoader from "./assets/userLoader.json";
import liquidLoader from "./assets/newLoader.json";
import PropTypes from "prop-types";

const CommentsLoader = ({ height, width, loop }) => {
  const defaultOptions = {
    loop: loop ?? false,
    autoplay: true,
    animationData: commentsLoader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div>
      <Lottie
        options={defaultOptions}
        height={height ?? 400}
        width={width ?? 400}
      />
    </div>
  );
};
const SendingLoader = ({ height, width, loop, style }) => {
  const defaultOptions = {
    loop: loop ?? false,
    autoplay: true,
    animationData: sendingLoader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      style={{
        ...style,
      }}
    >
      <Lottie
        options={defaultOptions}
        height={height ?? 400}
        width={width ?? 400}
      />
    </div>
  );
};
const SendAnimation = ({ height, width, loop, style }) => {
  const defaultOptions = {
    loop: loop ?? false,
    autoplay: true,
    animationData: sendAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      style={{
        ...style,
      }}
    >
      <Lottie
        options={defaultOptions}
        height={height ?? 400}
        width={width ?? 400}
      />
    </div>
  );
};
const LoadingReplies = ({ height, width, loop, style }) => {
  const defaultOptions = {
    loop: loop ?? false,
    autoplay: true,
    animationData: loadingReplies,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      style={{
        ...style,
      }}
    >
      <Lottie
        options={defaultOptions}
        height={height ?? 400}
        width={width ?? 400}
      />
    </div>
  );
};
const EmptyComments = ({ height, width, loop, style }) => {
  const defaultOptions = {
    loop: loop ?? false,
    autoplay: true,
    animationData: emptyComments,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      style={{
        ...style,
      }}
    >
      <Lottie
        options={defaultOptions}
        height={height ?? 400}
        width={width ?? 400}
      />
    </div>
  );
};
const LiquidLoader = ({ height, width, loop, style }) => {
  const defaultOptions = {
    loop: loop ?? false,
    autoplay: true,
    animationData: liquidLoader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <span
      style={{
        ...style,
      }}
    >
      <Lottie
        options={defaultOptions}
        height={height ?? 400}
        width={width ?? 400}
      />
    </span>
  );
};
const CalendarLoader = ({ height, width, loop, style }) => {
  const defaultOptions = {
    loop: loop ?? false,
    autoplay: true,
    animationData: calendarLoader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      style={{
        ...style,
      }}
    >
      <Lottie
        options={defaultOptions}
        height={height ?? 400}
        width={width ?? 400}
      />
    </div>
  );
};
const UserLoader = ({ height, width, loop, style }) => {
  const defaultOptions = {
    loop: loop ?? false,
    autoplay: true,
    animationData: liquidLoader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div
      style={{
        ...style,
      }}
    >
      <Lottie
        options={defaultOptions}
        height={height ?? 400}
        width={width ?? 400}
      />
    </div>
  );
};
// User Prop Types

UserLoader.defaultOptions = {
  height: 400,
  width: 400,
  loop: false,
  style: {},
};

UserLoader.propTypes = {
  children: PropTypes.element,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loop: PropTypes.bool,
  style: PropTypes.object,
};

// Calendar Prop Types

CalendarLoader.defaultOptions = {
  height: 400,
  width: 400,
  loop: false,
  style: {},
};

CalendarLoader.propTypes = {
  children: PropTypes.element,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loop: PropTypes.bool,
  style: PropTypes.object,
};

// Liquid  Prop Types

LiquidLoader.defaultOptions = {
  height: 400,
  width: 400,
  loop: false,
  style: {},
};

LiquidLoader.propTypes = {
  children: PropTypes.element,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loop: PropTypes.bool,
  style: PropTypes.object,
};
export {
  CommentsLoader,
  SendingLoader,
  SendAnimation,
  EmptyComments,
  LoadingReplies,
  LiquidLoader,
  CalendarLoader,
  UserLoader,
};
